//#region components/presence/presence_constants.js
var e = {
	BUSY: "busy",
	AWAY: "away",
	OFFLINE: "offline",
	ACTIVE: "active"
}, t = [
	e.BUSY,
	e.AWAY,
	e.OFFLINE,
	e.ACTIVE
];
//#endregion
export { e as PRESENCE_STATES, t as PRESENCE_STATES_LIST };

//# sourceMappingURL=presence-constants.js.map